// The ONE place the browser bundle reads its environment (WWW-S051).
//
// The marketing site is a 100% static multi-page bundle: anything in it is
// public, so it holds NO secrets (CLAUDE.md #9). Vite inlines `VITE_`-prefixed
// vars at BUILD time, which means each environment's bundle is built with its
// own values and there is no runtime lookup to get wrong.
//
// Everything here is a pure resolver over an env-like record, so the defaults
// are unit-tested without mutating `import.meta.env`. Add a var here and the
// structural guard in test/vite-env-vars.test.ts requires it in .env.example,
// src/vite-env.d.ts and .github/workflows/deploy-env.yml too — otherwise no
// deployed environment can ever set it.
//
// Not read here: VITE_SF_LEAD_API_BASE. That one is consumed at BUILD time by
// vite.config.ts (it is baked into the pre-register markup) and mapped per
// environment by bin/deploy.sh, so it never reaches the browser as config.

/**
 * The public Crisp website id (WWW-S051), or null when unset.
 *
 * Not a secret: it addresses a Crisp workspace, ships in the client bundle of
 * every site running Crisp, and authorizes nothing (CLAUDE.md #9 — same
 * reasoning the Broker Portal applies to the same value).
 *
 * Trimmed; blank or unset ⇒ **null, and live chat is off entirely**: no vendor
 * script, no vendor request, no widget. That default is deliberate — local
 * dev, Vitest and CI must not depend on a third party, and a chat window
 * nobody is staffing is worse than no chat window.
 */
export function resolveCrispWebsiteId(
  env: Record<string, string | undefined>,
): string | null {
  const raw = env.VITE_CRISP_WEBSITE_ID?.trim();
  return raw ? raw : null;
}

/** The running bundle's Crisp website id, read from Vite's inlined env. */
export function crispWebsiteId(): string | null {
  return resolveCrispWebsiteId(
    import.meta.env as unknown as Record<string, string | undefined>,
  );
}
